import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { ContactForm } from './components/ContactForm';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Footer } from './components/Footer';
export function App() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Nexora Virtual',
    description: 'Professional mobile app development and WordPress design agency based in London, UK.',
    url: 'https://nexoravirtual.com',
    telephone: '+44 7921 876472',
    email: 'admin@nexoravirtual.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'London',
      addressCountry: 'UK'
    },
    priceRange: '$$',
    serviceType: ['Mobile App Development', 'WordPress Development', 'Web Design']
  };
  return <HelmetProvider data-id="element-0">
      <div className="min-h-screen bg-gray-50 font-sans text-slate-900 selection:bg-[#FF6B35] selection:text-white" data-id="element-1">
        <Helmet data-id="element-2">
          <title data-id="element-3">
            Nexora Virtual | Mobile App Development & WordPress Design Agency
          </title>
          <meta name="description" content="Nexora Virtual is a premier London-based agency specializing in high-performance mobile app development and custom WordPress design solutions." data-id="element-4" />
          <link rel="canonical" href="https://nexoravirtual.com" data-id="element-5" />

          {/* Open Graph */}
          <meta property="og:title" content="Nexora Virtual | Mobile App Development & WordPress Design Agency" data-id="element-6" />
          <meta property="og:description" content="Specializing in high-performance mobile apps and custom WordPress solutions that drive growth. Based in London, UK." data-id="element-7" />
          <meta property="og:url" content="https://nexoravirtual.com" data-id="element-8" />
          <meta property="og:type" content="website" data-id="element-9" />
          <meta property="og:image" content="https://nexoravirtual.com/og-image.jpg" data-id="element-10" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" data-id="element-11" />
          <meta name="twitter:title" content="Nexora Virtual | Digital Agency" data-id="element-12" />
          <meta name="twitter:description" content="Professional mobile app development and WordPress design agency in London." data-id="element-13" />

          {/* Schema.org */}
          <script type="application/ld+json" data-id="element-14">
            {JSON.stringify(schemaData)}
          </script>
        </Helmet>

        <Navbar data-id="element-15" />
        <main data-id="element-16">
          <Hero data-id="element-17" />
          <Services data-id="element-18" />
          <ContactForm data-id="element-19" />
        </main>
        <Footer data-id="element-20" />
        <WhatsAppButton data-id="element-21" />
      </div>
    </HelmetProvider>;
}